import { createAction } from '@reduxjs/toolkit'

import { FlightSearchInitialValues } from '../../../../pages/Travel/components/FlightSearchWidget/FlightSearchWidget.types'

export const setFlightSearchValues = createAction<FlightSearchInitialValues>('flightSearchWidget/setValues')
